import React from "react"
import Cabecalho from "../Cabecalho"
import { Loading } from "../RegistradorDePedidos"
import { IntegracaoFluxForm } from "./components/IntegracaoFluxForm"

export function Index() {
    return (
        <>
            <Cabecalho pagina="Integração Flux Delivery" />
            <Loading />
            <IntegracaoFluxForm />
        </>
    )
}
